import React from "react";
import PropTypes from "prop-types";
import { SwipeableDrawer } from "@mui/material";
import styles from "./bottomDrawer.scss";
import "./bottomDrawer.css";
import { Image } from "../../assets/images/image.jsx";

export default function BottomDrawer(props) {
  const {
    submitButtonText,
    submitButtonWidth,
    children,
    open,
    onSubmit,
    setOpen,
    variantSelector,
  } = props;
  const onClose = () => setOpen(!open);
  const backColor = variantSelector ? "#fafafa" : "#ffffff";
  // 定义onOpen函数  
  const handleOpen = () => {
    console.log('Drawer is opening!');
    // 这里可以添加更多打开抽屉时你想执行的代码  
  };
  return (
    <div className={styles["drawer_div"]}>
      <SwipeableDrawer
        variant="temporary"
        anchor="bottom"
        open={open}
        ModalProps={{ onBackdropClick: () => onClose() }}
        className={"drawer-div"}
        disableSwipeToOpen={true}
        onClose={onClose}
        onOpen={handleOpen}
      >
        <div
          style={{
            background: "#fff",
            marginTop: "-2px",
          }}
        >
          <button
            className={styles["close_bar"]}
            onClick={onClose}
            style={{
              backgroundColor: backColor,
            }}
          >
            <div className={styles["bar"]}>{Image.barImage}</div>
          </button>
          <div className={styles["content-div"]}>
            {children}
            {submitButtonText && (
              <div className={styles["btn-div"]}>
                <button
                  className={styles["close-drawer"]}
                  style={{ width: submitButtonWidth }}
                  onClick={onSubmit}
                >
                  {submitButtonText}
                </button>
              </div>
            )}
          </div>
        </div>
      </SwipeableDrawer>
    </div>
  );
}

BottomDrawer.defaultProps = {
  submitButtonText: null,
  submitButtonWidth: 300,
  children: "",
  open: false,
};
BottomDrawer.propTypes = {
  submitButtonText: PropTypes.string,
  submitButtonWidth: PropTypes.number,
  children: PropTypes.node || PropTypes.string,
  open: PropTypes.bool,
};
